<!--
<div class="placeholder-back"></div>

<div class="contact">

    <div class="contact-header">
        <p class="contact-title">请与我们联系</p>
    </div>

    <div class="contact-content">

        <div class="contact-message">

            <div class="contact-tip">
                <p>给我们留言</p>
                <p>请给我们留言，我们会尽快的回复您。</p>
            </div>

            <form class="example-form" [formGroup]="contactForm" (ngSubmit)="submitForm()">
                <div class="loading-animation" *ngIf="loading">
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>

                <div class="combine-form-control">
                    <mat-form-field class="example-full-width">
                        <mat-label>{{ 'Name' | translate }}</mat-label>
                        <input matInput name="name" formControlName="name">
                        <mat-error *ngIf="contactForm.get('name')?.hasError('required')">{{ 'Contact.name-required' |
                            translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="example-full-width">
                        <mat-label>{{ 'CompanyName' |
                            translate }}</mat-label>
                        <input matInput name="company" formControlName="company">
                        <mat-error *ngIf="contactForm.get('company')?.hasError('required')">{{
                            'Contact.company-required' |
                            translate }}</mat-error>
                    </mat-form-field>
                </div>
                <mat-form-field class="example-full-width">
                    <mat-label>{{ 'Phone' | translate }}</mat-label>
                    <input matInput name="phone" formControlName="phone">
                    <mat-error
                        *ngIf="contactForm.get('phone')?.hasError('pattern')||contactForm.get('phone')?.hasError('required')">{{
                        'Contact.phonenumber-required' |
                        translate }}</mat-error>
                </mat-form-field>
                <mat-form-field class="example-full-width">
                    <mat-label>{{ 'Email' | translate }}</mat-label>
                    <input matInput name="email" formControlName="email">
                    <mat-error
                        *ngIf="contactForm.get('email')?.hasError('email')||contactForm.get('email')?.hasError('required')">{{
                        'Contact.email-required' |
                        translate
                        }}</mat-error>
                </mat-form-field>
                <mat-form-field class="example-full-width contact-message-textarea">
                    <mat-label>{{ 'Contact.Content' | translate }}</mat-label>
                    <textarea matInput name="content" formControlName="content"
                        class="contact-message-textarea-input"></textarea>
                    <mat-error *ngIf="contactForm.get('content')?.hasError('required')">{{ 'Contact.content-required' |
                        translate
                        }}</mat-error>
                </mat-form-field>
                <button class="font-size-large example-full-width " mat-raised-button color="primary">{{ 'submit' |
                    translate }}</button>
            </form>
        </div>

        <div class="contact-manner">
            <div class="contact-manner-worktime contact-manner-box">
                <img [src]="'/assets/images/phone.svg'" alt="">
                <p>{{ '+ 199 2846 8799' | translate }}</p>
            </div>

            <div class="contact-manner-email contact-manner-box">
                <img [src]="'/assets/images/mail.svg'" alt="">
                <p>{{"support@eprint.ink"}}</p>
            </div>

            <div class="contact-manner-address contact-manner-box">
                <img [src]="'/assets/images/address.svg'" alt="">
                <p>{{ 'Contact.Address' | translate }}</p>
            </div>
        </div>

    </div>
</div>
-->

<div class="placeholder-back"></div>

<div class="contact-page">
    <section class="contact-hero">
        <div class="contact-hero__eyebrow">Contact Us</div>
        <h1>请与我们联系</h1>
        <p>
            无论你正在咨询产品试用、部署方式、合作模式，还是想直接沟通当前业务需求，
            都可以通过下面的方式和我们取得联系。
        </p>
    </section>

    <section class="contact-layout">
        <aside class="contact-info">
            <div class="contact-info__intro">
                <p class="contact-info__title">给我们留言</p>
                <p class="contact-info__desc">留下你的联系方式和需求说明，我们会尽快安排对应同事与你沟通。</p>
            </div>

            <div class="contact-info__cards">
                <article class="contact-info__card">
                    <div class="contact-info__icon">
                        <img [src]="'/assets/images/phone.svg'" alt="">
                    </div>
                    <div>
                        <p class="contact-info__label">电话</p>
                        <p class="contact-info__value">+86 199 2846 8799</p>
                    </div>
                </article>

                <article class="contact-info__card">
                    <div class="contact-info__icon">
                        <img [src]="'/assets/images/mail.svg'" alt="">
                    </div>
                    <div>
                        <p class="contact-info__label">邮箱</p>
                        <p class="contact-info__value">support@eprint.ink</p>
                    </div>
                </article>

                <article class="contact-info__card">
                    <div class="contact-info__icon">
                        <img [src]="'/assets/images/address.svg'" alt="">
                    </div>
                    <div>
                        <p class="contact-info__label">地址</p>
                        <p class="contact-info__value">{{ 'Contact.Address' | translate }}</p>
                    </div>
                </article>
            </div>

            <div class="contact-info__note">
                <p>建议你在留言中直接说明：</p>
                <ul>
                    <li>当前业务类型或生产场景</li>
                    <li>希望了解的产品与功能</li>
                    <li>试用、采购或长期合作意向</li>
                </ul>
            </div>
        </aside>

        <div class="contact-form-card">
            <div class="contact-form-card__header">
                <p class="contact-form-card__title">在线留言</p>
                <p class="contact-form-card__desc">表单会直接发送到我们的商务沟通链路，请尽量填写完整。</p>
            </div>

            <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="submitForm()">
                <div class="loading-animation" *ngIf="loading">
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>

                <div class="combine-form-control">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>{{ 'Name' | translate }}</mat-label>
                        <input matInput name="name" formControlName="name">
                        <mat-error *ngIf="contactForm.get('name')?.hasError('required')">{{ 'Contact.name-required' |
                            translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>{{ 'CompanyName' | translate }}</mat-label>
                        <input matInput name="company" formControlName="company">
                        <mat-error *ngIf="contactForm.get('company')?.hasError('required')">{{
                            'Contact.company-required' | translate }}</mat-error>
                    </mat-form-field>
                </div>

                <div class="combine-form-control">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>{{ 'Phone' | translate }}</mat-label>
                        <input matInput name="phone" formControlName="phone">
                        <mat-error
                            *ngIf="contactForm.get('phone')?.hasError('pattern') || contactForm.get('phone')?.hasError('required')">{{
                            'Contact.phonenumber-required' | translate }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>{{ 'Email' | translate }}</mat-label>
                        <input matInput name="email" formControlName="email">
                        <mat-error
                            *ngIf="contactForm.get('email')?.hasError('email') || contactForm.get('email')?.hasError('required')">{{
                            'Contact.email-required' | translate }}</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field class="example-full-width contact-message-textarea" appearance="fill">
                    <mat-label>{{ 'Contact.Content' | translate }}</mat-label>
                    <textarea matInput name="content" formControlName="content"
                        class="contact-message-textarea-input"></textarea>
                    <mat-error *ngIf="contactForm.get('content')?.hasError('required')">{{ 'Contact.content-required' |
                        translate }}</mat-error>
                </mat-form-field>

                <button class="submit-button example-full-width" mat-raised-button color="primary">
                    {{ 'submit' | translate }}
                </button>
            </form>
        </div>
    </section>
</div>
